import * as types from '@/components/Database/database.types';
import i18n from '@/plugins/i18n';

const storageCardsData = [
  {
    label: i18n.global.t('dbm.card.cpuStorage'),
    width: '46.3%',
    show: true,
  },
  {
    label: i18n.global.t('dbm.card.memoryStorage'),
    width: '46.3%',
    show: true,
  },
];

const storageCardsDataMB = [
  {
    label: i18n.global.t('dbm.card.cpuStorage'),
    width: '46.3%',
    show: true,
  },
  {
    label: i18n.global.t('dbm.card.memoryStorageinMB'),
    width: '46.3%',
    show: true,
  },
];

const mongoHardwareCardsData = [
  {
    textLabel: i18n.global.t('dbm.osType'),
    textValColor: 'tangerine',
  },
  {
    textLabel: i18n.global.t('dbm.architecture'),
    textValColor: 'tangerine',
  },
  {
    textLabel: i18n.global.t('dbm.hostName'),
    textValColor: 'tangerine',
  },
  {
    textLabel: i18n.global.t('dbm.availability'),
    textValColor: 'tangerine',
  },
];

const usageCardData = [
  {
    textLabel: i18n.global.t('dbm.avgCPUUsage'),
    textValColor: 'tangerine',
    textValue: '0',
  },
  {
    textLabel: i18n.global.t('dbm.avgMemoryUsage'),
    textValColor: 'tangerine',
    textValue: '0',
  },
];
const cardName = [
  i18n.global.t('dbm.card.osType'),
  i18n.global.t('dbm.card.architecture'),
  i18n.global.t('dbm.card.hostName'),
  i18n.global.t('dbm.card.availability'),
];
const cardNamesMap = {
  [types.cardNames.TYPE_OF_OS]: types.cardValues.OS_TYPE,
  [types.cardNames.ARCHITECTURE]: types.cardValues.OS_ARCH,
  [types.cardNames.Host_Name]: types.cardValues.OS_NAME,
  [types.cardNames.Availability]: types.cardValues.AVAILABILITY,
};

const headerLegends = [
  {
    name: i18n.global.t('dbm.progressLegends.progressLegendUsed'),
    class: 'primary',
  },
  {
    name: i18n.global.t('dbm.progressLegends.progressLegendAvailable'),
    class: 'secondary',
  },
];

export {
  storageCardsData,
  storageCardsDataMB,
  mongoHardwareCardsData,
  usageCardData,
  cardNamesMap,
  cardName,
  headerLegends,
};
